var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"removable-file-field"},[_c('FileFrom',{attrs:{"value":_vm.value,"index":_vm.index},on:{"change":_vm.callbackOnChange}}),(_vm.index !== 0)?_c('RemoveElementButton',{attrs:{"callback":_vm.onRemove}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }